import { createContext } from "react";

export type RichTextHeadingType =
  | "heading1"
  | "heading2"
  | "heading3"
  | "heading4"
  | "heading5"
  | "heading6";

export type RichTextHtmlTag = "p" | "h1" | "h2" | "h3" | "h4" | "h5" | "h6";

/**
 * Replaces the HTML tag HyamPrismicRichText renders for a rich text heading
 * type (e.g. { heading1: "h2" }). Styling is not affected, only the tag.
 *
 * Editors choose headings in Prismic for how they look, but a page must have a
 * single <h1>. The slice zone provides { heading1: "h2" } to every slice that
 * is not a page hero, so only the hero's headline renders as <h1>.
 */
export const HeadingTagContext = createContext<
  Partial<Record<RichTextHeadingType, RichTextHtmlTag>>
>({});
